import { render } from "./SectionBorderAlways.vue?vue&type=template&id=f12c47a4"
const script = {}

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__